import { BaseDto } from "@/shared/dtos/base-dto";
import { recurso_data } from "./recurso_data";

export class recurso_dashboard extends recurso_data {
  public id_dashboard!: number;
  public id_recurso_data!: number;
}
